module.exports = __webpack_public_path__ + "img/Villa_Borna_7.8617c587.jpg";